import fp from 'lodash/fp';
import React from 'react';
import InstagramEmbed from 'react-instagram-embed';
import { Col, Row } from 'reactstrap';
import { branch, compose, lifecycle, renderNothing, withStateHandlers } from 'recompose';

const InstagramFeed = ({
  data: {
    instagram: {
      graphql: {
        user: {
          edgeOwnerToTimelineMedia: {
            edges
          }
        }
      }
    }
  }
}) => (
    <Row>
      {
        fp.map(({ node: { shortcode } }) =>
          <Col key={shortcode} xs={12} sm={6} md={4}>
            <InstagramEmbed
              url={`https://instagr.am/p/${shortcode}/`}
              hideCaption={true} />
          </Col>
        )(edges)
      }
    </Row>
  );

export default compose(
  branch(
    fp.negate(fp.get('data.instagram')),
    renderNothing
  ),
  withStateHandlers({
    loadedInstagram: false
  }, {
      onLoadInstagram: () => () => ({
        loadedInstagram: true
      })
    }),
  // https://github.com/sugarshin/react-instagram-embed/issues/21
  lifecycle({
    componentWillMount() {
      if (!window.instgrm) {
        const s = document.createElement('script')
        s.async = s.defer = true
        s.src = `https://platform.instagram.com/en_US/embeds.js`
        s.id = 'react-instagram-embed-script'
        s.onload = this.props.onLoadInstagram
        const body: HTMLElement | null = document.body
        if (body) {
          body.appendChild(s)
        }
      }
    }
  }),
  branch(
    () => !window.instgrm,
    renderNothing
  )
)(InstagramFeed);



// WEBPACK FOOTER //
// ./src/components/partials/instagram-feed/instagram-feed.js